import React from 'react';
import classNames from "classnames";

import Framework from "@beardeddevops/react.framework"
import {Objects, Parts} from "components";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import UserRoles, {MANAGER_PLUS_ROLES, USER_DIRECTORY_ROLES} from "constants/UserRoles";
import {Button, ButtonGroup, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import moment from "moment";
import TextField from "@material-ui/core/TextField";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import {Link} from "react-router-dom";

const breadcrumbsStatic = [{
	name: 'Users',
	url: '/users',
	icon: 'user',
}];

class User extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');

		this.state = {
			...this.state,
			name: '',
			toggleAuth: false,
			auth_code: ''
		};
	}

	handleData = (data) => {
		this.setState({name: `${data.name_first} ${data.name_last}`, hiring_pkey: data.hiring_pkey});
	}

	render() {
		let {match, history, baseUrl, reloadShell} = this.props;
		let {name} = this.state;

		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name,
				url: `/users/${match.params.id}`,
				icon: 'user',
			}
		]);

		//if you do !== here, it will reroute everytime
		const canViewOtherProfiles = this.props.roles.some(role => USER_DIRECTORY_ROLES.includes(role));
		if (match.params.id != this.props.rootState.user && !canViewOtherProfiles) {
			this.props.history.push('/dashboard');
		}

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={history}>
					<Button onClick={this.toggle('toggleAuth')} size={"sm"} color="primary">
						Verify
					</Button>
					{match.params.id != this.props.rootState.user && this.state.hiring_pkey && <Button size={"sm"} color="info">
						<Link to={'/hiring/candidates/' + this.state.hiring_pkey} style={{color: '#fff', fontWeight: 500}}>
							To Hiring Notes
						</Link>
					</Button>}
					{/*<Button data-cy="add-timeoff" onClick={this.toggle('modalTimeOff')} size={"sm"} color="primary">*/}
					{/*	Request Time Off*/}
					{/*</Button>*/}
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="User" value="details"/>
					{this.props.roles.some(role => MANAGER_PLUS_ROLES.includes(role)) && <Tab label="Uploaded Documents" value={'documents'}/>}
				</Tabs>

				<div className={classNames({'hidden': this.state.tab !== 'details'})}>
				  <Objects.User
						id={match.params.id}
						history={history}
						onData={this.handleData}
						reloadShell={reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						baseUrl={baseUrl}
						goBack={true}
						noDelete={this.props.roles.includes(UserRoles.Admin)}
						roles={this.props.roles}
					/>
				</div>

				<div className={classNames({'hidden' : this.state.tab !== 'documents'})}>
					{this.props.roles.some(role => MANAGER_PLUS_ROLES.includes(role)) && <Parts.UserDocsDisplay user={match.params.id}/>}
				</div>

				<Modal
					isOpen={this.state.toggleAuth}
					toggle={() => {
						this.setState({toggleAuth: false})
					}}
					size={"sm"}
					backdrop={true}
					style={{opacity: 1}}
				>
					<ModalHeader>
						Auth Code
					</ModalHeader>
					<ModalBody>
						<div className="form-group">
							<TextField
								fullWidth={true}
								size={"small"}
								label={"Auth Code"}
								value={this.state.auth_code}
								variant="outlined"
								onChange={(e) => {this.setState({auth_code: e.currentTarget.value})}}
							/>
						</div>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={async () => {
							let authModel = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
							authModel.object.auth_code = this.state.auth_code;
							authModel.object.pkey = this.props.rootState.user;
							await authModel.submit(null, 'POST_CHECK_AUTH_CODE')
							this.setState({toggleAuth: false})
						}}>Save</Button>
						<Button color="warning" onClick={async () => {
							let authModel = new API.BuildClass(Types.Users._name, API.RequestType.UPDATE);
							authModel.object.pkey = this.props.rootState.user;
							await authModel.submit(null, 'POST_RESEND_AUTH_CODE')
							this.setState({toggleAuth: false})
						}}>New Code</Button>
						<Button color="secondary" onClick={() => {
							this.setState({toggleAuth: false})
						}}>Close</Button>
					</ModalFooter>
				</Modal>

			</div>
		)
	}
}

export default Framework.Components.withRootState(User);